<template>
  <el-dialog
      title="Áp dụng tài khoản ngân hàng"
      :visible.sync="dialogVisible"
      width="560px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="sk-dialog"
  >
    <div class="sk-dialog-content">
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon" style="background: linear-gradient(135deg, #818cf8, #4f46e5)">
            <i class="el-icon-bank-card"></i>
          </div>
          <div>
            <p class="sk-panel-title">Áp dụng tài khoản ngân hàng</p>
            <p class="sk-panel-subtitle">Chọn tài khoản ngân hàng để áp dụng cho học sinh đã chọn.</p>
          </div>
        </div>
        <el-form
            label-width="190px"
            :model="dataInput"
            label-position="left"
            :rules="rules"
            ref="dataInput"
        >
          <el-form-item label="Chọn TK ngân hàng" prop="idFnBank">
            <el-select
                v-model="dataInput.idFnBank"
                filterable
                placeholder="Chọn tài khoản"
                style="width: 100%"
            >
              <el-option
                  v-for="item in responseList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.bankName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Số tài khoản" prop="accountNumber">
            <el-input v-model="accountNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="Chủ tài khoản" prop="userBank">
            <el-input v-model="userBank" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer sk-dialog-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialogByButton('dataInput')">
        <i class="el-icon-circle-close" />
        <span>Đóng</span>
      </el-button>
      <el-button
          class="btn-save"
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm('dataInput')"
      >
        <i class="el-icon-circle-check" />
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import StudentService from "@/services/StudentService";

export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      dataSuccess: null,
      loadingButton: false,
      accountNumber: "",
      userBank: "",
      responseList: [],
      dataInput: {
        idFnBank: "",
        idKidList: [],
      },
      rules: {
        idFnBank: [
          {
            required: true,
            message: "Tài khoản không được để trống",
            trigger: "blur",
          },
          {
            required: true,
            message: "Tài khoản không được để trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    'dataInput.idFnBank'(newVal) {
      const selectedItem = this.responseList.find(item => item.id === newVal);
      this.userBank = selectedItem.fullName;
      this.accountNumber = selectedItem.accountNumber;
    }
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.userBank = ""
      this.accountNumber = ""
      this.$refs["dataInput"].resetFields();
      this.$emit("dialog-close");
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.userBank = ""
      this.accountNumber = ""
      this.$emit("dialog-close");
    },

    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          StudentService.createBankKids(this.dataInput)
              .then((response) => {
                this.dataSuccess = response.data.data;
                this.$message({
                  message: "Áp dụng tài khoản thành công",
                  type: "success",
                });
                setTimeout(() => {
                  this.closeDialogByButton(fromData);
                }, 500);
              })
              .catch((err) => {
                this.$message({
                  message: err.response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        } else {
          console.log("error validate data!");
          return false;
        }
      });
    },

    getData(data) {
      this.dataInput.idKidList = data.map(kid => kid.id);
      this.loadingData = true;
      this.textTable = "";
      StudentService.findBankInfo()
          .then((resp) => {
            this.responseList = resp.data.data;
          })
          .catch((err) => {
            if (err.response.status === 403) {
              this.$router.push("/error/forbidden");
            } else {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            }
            this.responseList = [];
            console.log(err)
          })
          .finally(() => {
            if (this.responseList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
